define([
    'angularRouter'
], ()=> {
    // Connects to localhost by default.
    // Options: 'http://uxui-dev.guidewire.com'
    const HOST_TO_CONNECT = /*backEndUrlPrefix_START*/''/*backEndUrlPrefix_END*/;

    var getPaymentDetails = function(){
        var link = window.location;
        var paymentDetails = {
            appID:"0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b",
            appKey:"eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9",
            url:'<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/default.aspx"></iframe>'
        };

        if ((link.host.indexOf("aaadev") >= 0 || link.host.indexOf("gwdev") >= 0 || link.host.indexOf("aaamsdf") >= 0 || link.host.indexOf("aaamshf") >= 0) || link.host.indexOf("aaadatamigration") >= 0) {
            paymentDetails.appID="0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b";
            paymentDetails.appKey="eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9";
            paymentDetails.url='<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/default.aspx"></iframe>';
        }
        else if ((link.host.indexOf("aaatest") >= 0 || link.host.indexOf("gwtest") >= 0 || link.host.indexOf("aaamstest") >= 0)) {
            paymentDetails.appID="0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b";
            paymentDetails.appKey="eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9";
            paymentDetails.url='<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/default.aspx"></iframe>';
        }
        else if ((link.host.indexOf("aaasit") >= 0 || link.host.indexOf("gwsit") >= 0)) {
            paymentDetails.appID="0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b";
            paymentDetails.appKey="eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9";
            paymentDetails.url='<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/default.aspx"></iframe>';
        }
        else if ((link.host.indexOf("aaatrain") >= 0 || link.host.indexOf("gwtrain") >= 0)) {
            paymentDetails.appID="0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b";
            paymentDetails.appKey="eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9";
            paymentDetails.url='<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/default.aspx"></iframe>';
        }
        else if (link.host.indexOf("www.aaacarolinasinsurancesolutions.com") >= 0 || link.host.indexOf("aaacarolinasinsurancesolutions.com") >= 0) {
            paymentDetails.appID="27fca103-0328-453d-b974-79876be7ff3e";
            //paymentDetails.appKey="eyJDb25zdW1lckFwcElkIjoiMjdmY2ExMDMtMDMyOC00NTNkLWI5NzQtNzk4NzZiZTdmZjNlIiwiQXBpQXBwSWQiOiJjYzgyODY4Mi1jYmFkLTQwZmYtODA0Yy03MzVjMDFjYzNiZTIiLCJBcGlBcHBLZXkiOiJERVJzV2swTVpSL0I0Zyt3bkplWWZsTlpmUWFUOGdCZWRmS2ZZcGhNd1NmdzhBU2N0anNBQlM4bGlSZ01kOGFZUy9Ebnp6cm0ySkE4Rm4rRUpnaWNjbUxDVXZKUEt6LzhuZWNMbzFTSEQxaU5MRWZXNEJRekxoRlR2VXEwakF5ZSJ9";
            paymentDetails.appKey="eyJDb25zdW1lckFwcElkIjoiMjdmY2ExMDMtMDMyOC00NTNkLWI5NzQtNzk4NzZiZTdmZjNlIiwiQXBpQXBwSWQiOiIwOTM3YzkwNy03NzQ2LTRiOTUtOWRmZC0xMmZiYTVhODVlMTQiLCJBcGlBcHBLZXkiOiJGeUxVNzRvZjI4VFpEMFJpV2Q5ZFk5d2wvdzh5RzdnVXFhRnM3N0dmclc4a2QwekNzTGxVTXptTkFFS2tnZVY0bW5yOTBGYlU4T3crSEI5RTlJbVVWZHV1OFVVNnlVQ3BhdmhHbnJVWTdmRkFDS2xVb1lDeEZHMGVCN211V2pmNCJ9";
            paymentDetails.url='<iframe id="payment-page" src="https://pay.carolinas.aaa.com/default.aspx"></iframe>';
        }
        else{
            paymentDetails.appID="0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b";
            paymentDetails.appKey="eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9";
            paymentDetails.url='<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/default.aspx"></iframe>';
        }
        return paymentDetails;
    };

    var paymentDetails = getPaymentDetails();

    /**
     * Module used to define application level configuration parameters that should be
     * passed to capability modules
     */
    return angular.module('portal.config', ['ui.router'])

        /**
         * Defines the prefix url where the set of states for a sub module should
         * plug into the portal application
         */
        .constant('state_plugin_config', {
            quote_bind: 'root',
            //changed for AAA; make account lookup page as home page
            // CHG0031104 - Changed back to Zipcode page
            home: 'zipCode',
//            home: 'landingAccount',
            quickQuote: 'quickQuote'
        })



        .constant('httpSettings', {
            'timeout': 90000,
            'reloadQueryParamName': 'goto',
            'reloadURL': '/index.html',
            'serviceBaseURLs': {
                'pc': `${HOST_TO_CONNECT}/pc/service/edge/`,
                'quote': `${HOST_TO_CONNECT}/quote/`,
                'vinlookup': `${HOST_TO_CONNECT}/vehicleinfo/`,
                'aaalookup': `${HOST_TO_CONNECT}/vehicleinfo/`,
                 'aaahldilookup': `${HOST_TO_CONNECT}/vehicleinfo/`,
                'availability': `${HOST_TO_CONNECT}/quote/`,
                'addressLookup': `${HOST_TO_CONNECT}/address/`,
//                'accountlookup': `${HOST_TO_CONNECT}/quote/`,
                'membership': `${HOST_TO_CONNECT}/quote/`,
                'discounts' :`${HOST_TO_CONNECT}/quote/`,
                'mvrclue' :`${HOST_TO_CONNECT}/quote/`,
				'auth': `${HOST_TO_CONNECT}/auth/`,
                'addressstandardization': `${HOST_TO_CONNECT}/address/`,
                'prefill': `${HOST_TO_CONNECT}/quote/`,
                'custompayment': `${HOST_TO_CONNECT}/quote/`

            },
            auth: {
                kind: 'basic',
                username: 'upstream',
                password: 'password'
            }
        })

        .constant('defaultLocaleDetails', {
            countryCode: 'US',
            mapCenter: {lat: 37.923933, lon: -122.5203}
        })

		//TODO:used for login from dev and test environment. To be changed when moving to other environments.
        .constant('LoginLinkDev','https://stg.theagentszone.com/portallogin/Account/Login')
        .constant('LoginLinkTest','https://stg.theagentszone.com/portallogintst/Account/Login')
        .constant('AAADEV','aaadev')
        .constant('AAATEST','aaadev')
        .constant('GWDEV','gwdev')
        .constant('GWTEST','gwtest')

        .constant('PayTestUrl','https://paytest.carolinas.aaa.com')
        .constant('PayProdUrl','https://pay.carolinas.aaa.com')



        .constant('CCDEV_APPID',paymentDetails.appID)
        .constant('CCDEV_APPKEY',paymentDetails.appKey)
        .constant('CCDEV_PAYMENTURL',paymentDetails.url)
        .constant('CCDEV_MID','1')
        .constant('CCDEV_PAYMENTID','6') //INC2460206 - Changed from 7 to 6 - AB - 01/28/2021

        //.constant('CCDEV_APPID','0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b')
        //.constant('CCDEV_APPKEY','eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9')
        //.constant('CCDEV_PAYMENTURL','<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/payment-page.html"></iframe>')

        //Used for date of birth dropdowns.
        .constant('AgeAllowedForHO', 18)
        .constant('AgeAllowedToDrive', 16)
        .constant('LicensedAgeAllowedToDrive', 16)
        .constant('MaximumAge', 100)
        .constant('maxFileUploadSize', 50000000)//50MB. Used to specify the maximum file size for document upload.

        .config(['$stateProvider', '$urlRouterProvider', ($stateProvider, $urlRouterProvider)=> {
            const states = [
                {
                    name: 'root',
                    url: '',
                    template: '<div ui-view></div>',
                    abstract: true,
                    data: {
                        defaultState: 'zipCode' //; Changed for AAA : set account lookup page as default page
                        // CHG0031104 - Changed back to Zipcode page
//                        defaultState:'landingAccount'
                    }
                }
            ];

            for (let i = 0; i < states.length; i++) {
                $stateProvider.state(states[i]);
            }

            //changed for AAA : set account lookup page as default home page
            // CHG0031104 - Changed back to Zipcode page
            $urlRouterProvider.when('home', 'zipCode');
            $urlRouterProvider.otherwise('zipCode');
        }])

        .constant('ASYNC_TRANSLATIONS', true)//Constant that allows us to load translations synchronously (tests/Components Examples)
        .constant('ANGULARI18N_PRESET', '')//Constant that allows us to load Angular Locale from different path (Components Examples)
        .constant('TRANSLATE_PROVIDER_PREFIX', '');//Constant that allows us to load translations from different path (Components Examples)
});



/** WEBPACK FOOTER **
 ** ./app/js/portal/config.js
 **/